import linkRuleDark from '../../common/algorithms/link-rule-dark';

const firstCondition = (ratio) => ratio >= 3;
const secondCondition = (ratio) => ratio < 12;

const dark = (params) => linkRuleDark(params, { firstCondition, secondCondition });

export default dark;
